interface Props {
  index?: string;
  label: string;
  title: string;
  intro?: string;
  dark?: boolean;
  /** false → keep legacy CSS reveal (used inside pinned / theme-driven sections) */
  motion?: boolean;
}

export default function SectionHead({ label, title, intro, dark = false, motion = true }: Props) {
  const mo = motion ? 'fade' : undefined;
  return (
    <div className={`${motion ? '' : 'reveal'} max-w-3xl`}>
      <p data-mo={mo} className="eyebrow text-primary-500">{label}</p>
      <h2 data-mo={motion ? 'title' : undefined} className={`mt-5 h-section ${dark ? 'text-foreground-50' : 'text-foreground-950'}`}>{title}</h2>
      {intro && <p data-mo={mo} className={`mt-6 max-w-xl t-body ${dark ? 'text-foreground-300' : 'text-foreground-600'}`}>{intro}</p>}
    </div>
  );
}